
import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import '@angular/common/locales/global/nl';
import { AppModule } from './app/app.module';

if (!localStorage.getItem('locale')) {
  localStorage.setItem('locale', 'nl');
}

document.documentElement.lang = localStorage.getItem('locale') || 'nl';

platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()],
}).catch(err => console.error(err));
